import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { setIsSelectedFlags } from '../../../redux/actions/player-actions';
import { initializePollyProcess } from './pollyProcess';

class FlagRowHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { listOfUrls: [] };
  }

  render() {
    const { podcast, document, flags } = this.props;
    return (
      <Row>
        <Col xs={9} style={{}}>
          <div className="flags-list-item__header-wrapper">
            <h4>{podcast}</h4>
            <h5>{typeof document === 'object' ? (document?.documentName || JSON.stringify(document)) : document}</h5>
          </div>
        </Col>
        <Col xs={3} style={{}}>
          <div
            className="flags-list-item__play-all"
            onClick={(e) => {
              this.props.dispatch(setIsSelectedFlags(false));
              initializePollyProcess(
                e,
                flags,
                false,
                this.props.handleFlagPlay
              );
            }}
          >
            <i className={`fa fa-play`} aria-hidden="true" />
            <span style={{ cursor: 'pointer' }}>Play all</span>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    playerFlag: store.player.playerFlag,
    playbackFlags: store.app.playbackFlags
  };
};

export default connect(mapStateToProps)(FlagRowHeader);
